import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoBuildingSmall = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>BuildingSmall</title>
    <path
      clipRule="evenodd"
      d="M26.961 18.035h-4.216 4.216ZM26.961 22.44h-4.216 4.216Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.319 13.262h7.928c.737 0 1.334.597 1.334 1.334v13.35M4.517 27.947V5.05c0-.736.597-1.333 1.334-1.333h11.134c.736 0 1.333.597 1.333 1.333v22.896"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M13.842 9.225h-4.85 4.85ZM13.842 13.63h-4.85 4.85ZM13.842 18.035h-4.85 4.85ZM13.842 22.44h-4.85 4.85Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.155 27.944h27.69" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default SvgIcoBuildingSmall;
